export const TITLE_INFO = {
  PROP_TYPES:
    "The type of properties available for your dream home or investment.",
  TOP_CITIES: "Find Places to Buy in these Cities",
  MOST_VIEWED: "The properties which are most viewed recently",
};

export const TITLES = {
  TRAINING_FILES: "Training Files",
  TRAINING_ASSIGNMENTS: "Training Assignments",
  TRAINING_STATUS: "Training Status",
  APPROVAL_LIST: "Approval List",
  DOC_LIST: "Document List",
  LEAD_VISITS: "Lead Visits",
  LEAD_ASSIGNMENTS: "Lead Assignments",
  GET_ALL_LEADS: "Get All Leads",
  TRAINING_ASSIGN: "Training Assign",
  TRAINING_VIEW: "View Training",
  TRAINING: "Training",
  PRODUCT: "Product",
  CATEGORY: "Category",
  TAX: "Tax",
  DLR_PRE_APPOINTMENT_FORM: "DLR Pre Appointment Form",
  REGION: "Region",
  CURRENCY: "Currency",
  CITY: "City",
  USER: "User",
  CRM_DASHBOARD: "CRM Dashboard",
  LEAD_PROFILE: "Lead Profile",
  COUNTRY: "Country",
  STATE: "State",
  BEAT: "Beat",
  BEAT_PJP: "Beat/PJP",
  GRAMS: "Grams",
  BOX: "Box",
  SUB_CATEGORY: "Sub Category",
  ROI: "ROI",
  ROI_CALCULATER: "ROI Calculator",
  CRM_REPORTS: "CRM Reports",
  TRAINING_REPORTS: "Training Reports",
};

/*
 * Description for the page (Title)
 */
export const SUB_TITLES = {
  TRAINING_REPORTS: "Training Reports",
  TRAINING_FILES: "Training Files",
  TRAINING_ASSIGNMENTS: "Training Assignments",
  TRAINING_STATUS: "Training Status",
  APPROVAL_LIST: "Approval List",
  DOC_LIST: "Document List",
  LEAD_VISITS: "Lead Visits",
  LEAD_ASSIGNMENTS: "Lead Assignments",
  GET_ALL_LEADS: "Get All Leads",
  TRAINING_ASSIGN: "Training Assign",
  TRAINING_VIEW: "View Training",
  TRAINING: "Training",
  PRODUCT: "Product",
  CATEGORY: "Category",
  TAX: "Tax",
  DLR_PRE_APPOINTMENT_FORM: "DLR Pre Appointment Form",
  REGION: "Region",
  CURRENCY: "Currency",
  CITY: "City",
  USER: "User",
  USERS: "Manage Users",
  CRM_DASHBOARD: "CRM Dashboard",
  COUNTRY: "Country",
  STATE: "State",
  BEAT: "Beat",
  BEAT_PJP: "Beat/PJP",
  GRAMS: "Grams",
  BOX: "Box",
  SUB_CATEGORY: "Sub Category",
  LEAD_PROFILE: "Lead Profile",
  ROI: "ROI",
  ROI_CALCULATER: "ROI Calculator",
  CRM_REPORTS: "CRM Reports",
};

/*
 * Form Labels, Grid Column names, etc..
 */
export const LABELS = {
  TRAINING_ASSIGN: "Training Assign",
  TRAINING_VIEW: "View Training",
  UPLOAD_TYPE: "Upload Type",
  TRAINING_CAT: "Training Category",
  TRAINING_COMMENT: "Training Comment",
  DURATION: "Duration",
  TRAING_MANDATORY: "Is Training Mandatory?",
  BACK: "Back",
  ASSIGNED_DATE: "Assigned Date",
  ASSIGNED_BY: "Assigned By",
  ASSIGNED_TO: "Assigned To",
  ASSIGN: "Assign",
  QUALIFY: "Qualify",
  CRM: "CRM",
  TRAINING: "Training",
  MIN_PRISE: "Min. Prise",
  PRISE: "Prise",

  MRP: "MRP",
  SUB_CATEG: "Sub Categ.",
  MAIN_CATEG: "Main Categ.",
  PRODUCT_NAME: "Product Name",
  PRODUCT: "Product",
  ALIAS: "Alias",
  CATEGORY: "Category",
  CGST: "CGST %",
  SGST: "SGST %",
  IGST: "IGST %",
  TAXES_NAME: "Taxes Name",
  ACCESS_VERIFICATION: "Access Verification",
  OLD: "Old",
  PACK_BODY: "Pack Body",
  NO_OF_VEHICLE: "No Of Vehicle",
  LOGISTICS_VERIFICATION: "Logistics Verification",
  OWN: "Own",
  RENTED: "Rented",
  YES: "Yes",
  NO: "No",
  SIZE_OF_GODOWN: "Size Of Godown",
  PHY_GODOWN_VERIFICATION: "Physical Godown Verification",
  CONTACT_PERSON: "Contact Person",
  FIRM_NAME: "Firm Name",
  AGENCY_DETAILS: "Agency Details",
  NEW_DLR_PRE_APPOINTMENT_FORM: " New DLR Pre Appointment Form",
  DLR_PRE_APPOINTMENT_FORM: "DLR Pre Appointment Form",
  CURRENCY_CODE: "Currency Code",
  COUNTRY: "Country",
  CURRENCY_SYMBOL: "Currency Symbol",
  CURRENCY: "Currency",
  POPULATION: "Population",
  TOTAL_SHOPS: "Total Shops",
  REGION: "Region",
  ACTIVE_STATUS: "Active Status",
  USER: "User",
  MASTERS: " Masters",
  PARTER_DETAIL: "Partner Detail",
  EDIT_CRM_DASHBOARD: "Edit Crm Dashboard",
  NEW_CRM_DASHBOARD: " New Crm Dashboard",
  WORKING_CAPITAL: "Working Capital",
  INVESTMENT_CAPACITY: "Investment Capacity",
  CAPITAL_DETAILS: "Capital Details",
  VEHICAL_DETAILS: "Vehicle Detail",
  LOGISTIC_DETAILS: "Logistics Detail",
  GODOWN_SIZE: "Godown Size",
  STORAGE_FACILITY: "Storage Facility",
  TRANSPORT_FACILITY: "Transport Facility",
  STORAGE_DETAILS: "Storage Details",
  EXP_DETAILS: "Experience Details",
  OTHER_EXP: "Other Experience",
  PARTNER_PHONE: "Partner Phone",
  PARTNER_AGE: "Partner Age",
  PARTNER_MOB_2: "Partner Mobile Number 2",
  PARTNER_MOB_1: "Partner Mobile Number 1",
  PARTNER_PIN: "Partner PIN",
  PARTNER_CURRENT_ADDRESS: "Partner Current Address",
  PARTNER_STATE: "Partner State",
  PARTNER_TALUKA: "Partner Taluka",
  PARTNER_DIST: "Partner District",
  PARTNER_DOB: "Partner Date Of Birth",
  PARTNER_LAST_NAME: "Partner Last Name",
  PARTNER_MIDDLE_NAME: "Partner Middle Name",
  PARTNER_FIRST_NAME: "Partner First Name",
  PARTNER_DETAILS: "Partner Details",
  EDUCATIONAL_POST_GRADUATION_CIRTIFICATE:
    "Educational Post Graduation Certificate",
  EDUCATIONAL_GRADUATION_CIRTIFICATE: "Educational Graduation Certificate",
  EDUCATIONAL_HSC: "Educational HSC",
  EDUCATIONAL_SSC: "Educational SSC",
  EDUCATIONAL_DETAILS: "Educational Details",
  COMPANY_PIN: "Company PIN",
  FIRM_TYPE: "Firm Type",
  COMPANY_STATE: "Company State",
  COMPANY_TALUKA: "Company Taluka",
  COMPANY_DIST: "Company District",
  COMPANY_ADDRESS: "Company Address",
  COMPANY_EMAIL: "Company Email",
  COMPANY_NAME: "Company Name",
  COMPANY_DETAIL: "Company Details",
  AGE: "Age",
  MOB_2: "Mobile Number 2",
  MOB_1: "Mobile Number 1",
  PIN: "PIN",
  PERSONAL_STATE: "Personal State",
  PERSONAL_TALUKA: "Personal Taluka",
  PERSONAL_DIST: "Personal District",
  PERSONAL_DETAILS: "Personal Detail",
  CURRENT_ADDRESS: "Current Address",
  DOB: "Date Of Birth",
  APPLICATION_DT: "Application Date",
  DIST: "District",
  MIDDLE_NAME: "Middle Name",
  CURRENT_DETAILS: "Current Details",
  NEW_LEAD_PROFILE: "New Lead Profile",
  RELOAD: "Reload",
  ADD: "Add",
  ADD_NEW: "Add New",
  ADD_NEW_ROW: "Add New Row",
  LEAD_PROFILE: "Lead Profile",
  ROUTE_LIST_REPORT: "Route List Report",
  PRICE_LIST_REPORT: "Price List Report",
  PRODUCT_LIST_REPORT: "Product List Report",
  LEADS_REPORT: "Leads Report",
  FEEDBACK_REPORT: "Feedback Report",
  INSTRUCTION_REPORT: "Instruction Report",
  SURVEY_REPORT: "Survey Report",
  CUSTOMER_LIST_REPORT: "Customer List Report",
  LEAVES_REPORT: "Leaves Report",
  ATTENDANCE_REPORT: "Attendance Report",
  CITIES_LIST_REPORT: "Cities List Report",
  TEAM_DETAIL_REPORT: "Team Detail Report",
  BEAT_LIST_REPORT: "Beat List Report",
  BEAT_LOG_REPORT: "Beat Log Report",
  ORDER_DETAIL_REPORT: "Order Detail Report",
  SCHEMES_DETAIL_REPORT: "Scheme Detail Report",
  TARGET_DETAIL_REPORT: "Target Detail Report",
  SCHEME_UTILIZATION_REPORT: "Scheme Utilization Report",
  TARGET_ACHIEVED_REPORT: "Target Status - Product",
  TARGET_ACHIEVED_TOTAL_REPORT: "Target Status - Total",
  ALL_LOGS_REPORT: "All Logs Report",
  CUSTOMER_ORDERS: "Customer Orders",
  CATEGORY_WISE_SALES: "Category Wise Sales",
  MAIN_CATEGORY_WISE_SALES: "Main Category Wise Sales",
  SUB_CATEGORY_WISE_SALES: "Sub Category Wise Sales",
  PRODUCT_WISE_SALES: "Product Wise Sales",
  STATE_WISE_SALES: "State Wise Sales",
  REGION_WISE_SALES: "Region Wise Sales",
  CITY_WISE_SALES: "City Wise Sales",
  AREA_WISE_SALES: "Area Wise Sales",
  CUSTOMER_WISE_SALES: "Customer Wise Sales",
  CUSTOMER_TYPE_WISE_SALES: "Customer Type Wise Sales",
  SCHEME: "Scheme",
  PRICE: "Price",
  QUESTION: "Question",
  GPT_MASTER: "GPT Master",
  MINUTES_OF_MEETING: "Minutes of Meeting",
  WORK_PACKAGE: "Work Package",
  WORK_PACKAGES: "Work Packages",
  PL: "Paid Leaves",
  SL: "Sick Leaves",
  LEAVE_PLANNER_APPROVE: "Leave Approval",
  ADMIN_COMMENTS: "Admin Comments",
  ORG_CHART: "Organization Chart",
  TIME_SHEET_APPROVE: "Timesheet Approve",
  NOTES: "Notes",
  TERMS: "Terms",
  DUE_DATE: "Due Date",
  PRINT: "Print",
  INVOICES: "Invoices",
  INVOICE_PRINT: "Invoice Print",
  SELECT_TAX: "Select Tax",
  DATE_OF_INVOICE: "Invoice Date",
  PRINT_PAYSLIP: "Print Payslip",
  COMMENTS: "Comments",
  PRESENT_DAYS: "Present Days",
  ABSENT_DAYS: "Absent Days",
  TOTAL_WORKING_DAYS: "Total Working Days",
  PAY_ROLL: "Pay Roll",
  NET_PAY: "Net Pay",
  TDS: "TDS",
  PROFESSIONAL_TAX: "Professional Tax",
  TOTAL_SALARY: "Total Salary",
  MONTH_END_DATE: "Month End Date",
  MONTH_START_DATE: "Month Start Date",
  PHOTO: "Photo",
  LEAVE_PLANNER: "Leave Planner",
  PRINT_CV: "Print CV",
  SELECTED_PROF_HISTORY: "Selected Profile History",
  RECENT_PROF_HISTORY: "Recent Profile History",
  KEY_EXPERIENCE: "Key Experience",
  COUNTRIES_WORKED_IN: "Countries Worked In",
  KEY_SKILLS: "Key Skills",
  COURSE: "Course",
  QUALIFICATION: "Qualification",
  PROFESSION: "Profession",
  ADD_CV: "Add/Edit CV",
  PROJECT_COUNTY: "Project County",
  CLIENT_COUNTY: "Client County",
  CONTACT_COUNTY: "Contact County",
  PROJECT_VALUE: "Project Value",
  BUDGET_FOR_EXECUTION: "Budget For Execution",
  PROJECT_AWARD_DATE: "Project Award Date",
  CONTACT_EMAIL_ID: "Contact Email ID",
  CONTACT_EIR_CODE: "Contact EIR Code",
  CONTACT_COUNTRY: "Contact Country",
  CONTACT_ADDRESS_1: "Contact Address 1",
  CONTACT_ADDRESS_2: "Contact Address 2",
  CONTACT_ADDRESS_3: "Contact Address 3",
  CONTACT_NAME: "Contact Name",
  CLIENT_EIR_CODE: "Client EIR Code",
  CLIENT_COUNTRY: "Client Country",
  CLIENT_ADDRESS_1: "Client Address 1",
  CLIENT_ADDRESS_2: "Client Address 2",
  CLIENT_ADDRESS_3: "Client Address 3",
  PROJECT_EIR_CODE: "Project EIR Code",
  PROJECT_COUNTRY: "Project Country",
  PROJECT_ADDRESS_1: "Project Address 1",
  PROJECT_ADDRESS_2: "Project Address 2",
  PROJECT_ADDRESS_3: "Project Address 3",
  PROJECT_CLOSE_DATE: "Project Close Date",
  PROJECT_START: "Project Start",
  PROJECT_FINISH: "Project Finish",
  CLIENT_NAME: "Client Name",
  BLOOD_GROUP: "Blood Group",
  PERMANENT_ADDRESS: "Permanent Address",
  PRESENT_ADDRESS: "Present Address",
  PERSONAL_EMAIL: "Personal Email",
  OFFICE_EMAIL: "Office Email",
  E_CONTACT_NUMBER: "Emergency Contact No.",
  RESOURCE_PLANNING: "Resource Planning",
  TIME_SHEET: "Time Sheet Booking",
  TIME_SHEET_APPROVAL: "Approve Time Sheet",
  PAY_SLIP: "Pay Slip",
  INVOICE: "Invoice",
  DATE: "Date",
  FROM_DATE: "From",
  TO_DATE: "To",
  EMPLOYEE: "Employee",
  NORMAL_HRS: "Normal Hours",
  DESIGNATION_MASTER: "Designation Master",
  DESIGNATION: "Designation",
  RESPONSIBILITY_MASTER: "Responsibility Master",
  RESPONSIBILITY: "Responsibility",
  LEVEL: "Level",
  PROJECT_TYPE_MASTER: "Project Type Master",
  PROJECT_TYPE: "Project Type",
  TASK_MASTER: "Task Master",
  TASK: "Task",
  HOLIDAY_MASTER: "Holiday Master",
  HOLIDAY: "Holiday",
  HOLIDAY_DATE: "Holiday Date",
  HOLIDAY_NAME: "Holiday Name",
  EMPLOYEE_MASTER: "Employees List",
  EMPLOYEE_ID: "Employee ID",
  EMPLOYEE_NAME: "Employee Name",

  STATUS: "Status",
  SCHEDULE_UPDATE_FREQUENCY: "Schedule Update Frequency",
  RISKS_REGISTER: "Risks Register",
  NEW_PASSWORD: "New Password",
  CURRENT_PASSWORD: "Current Password",
  SETTINGS: "Settings",
  CONSTRAINTS: "Constraints",
  SPENT_HRS: "Spent Hours",
  TASK_OWNER: "Task Owner",
  EMP_ID: "Employee ID",
  SELECT_DATE: "Status/Data Date",
  GEO_REPORT: "Geography Report",
  RESOURCE_PLANNING_REPORT: "Resource Planning Report",
  PROJECTS_REPORT: "Projects Report",
  TIME_SHEET_REPORT: "Time Sheet Report",
  INVOICE_REPORT: "Project Invoice Report",
  INVOICE_REGISTER: "Invoice Register",
  COST_REPORT: "Cost Report",
  APPROVAL_LOG_REPORT: "Approval Log Report",
  USER_LOG_REPORT: "User Log Report",
  EMPLOYEE_LEAVES_REPORT: "Employee Leaves Report",
  VIEW: "View",
  APPROVE: "Approve",
  REJECT: "Reject",
  APPROVE_FILE: "Approve File",
  COST: "Cost",
  UNIT: "Unit",
  QTY: "Qty.",
  EXPORT_TO_PDF: "Export To PDF",
  SIX_WEEKS_VIEW: "6 Weeks View",
  ONE_MONTH_VIEW: "1 Month View",
  SHOW_ALL: "Show All",
  TASK_NAME: "Discipline",
  REPORTS: "Reports",
  REPORT1: "Drill Down",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_CHART: "Project Chart",
  PROJECT_CRITICAL_PATH: "Project Critical Path",
  WEEK_LOOK_AHEAD_SCHEDULE: "Week Look Ahead Schedule",
  PROJECT_REMAINING_DURATION: "Project Remaining Duration",
  EXPAND_ALL: "Expand All",
  PERCENTAGE: "Percentage",
  CRITICAL_PATH: "Critical Path",
  NEAR_TO_CRITICAL_PATH: "Near To Critical Path",
  PROJECT_CASH_FLOW: "Project Cash Flow",
  PROGRESS_CURVE: "Progress S Curve",
  MAN_HOURS_DISTRIBUTION: "Man Hours Distribution",
  RESOURCE_TABLE: "Resource Table",
  FINISH_DATE: "Finish Date",
  START_DATE: "Start Date",
  EDIT_CHART: "Edit Chart",
  PROJECT_OVERVIEW: "Project Overview",
  PROJECT_PROGRESS_STATUS: "Project Progress Status vs Earned",
  MAN_HOURS_PLAN: "Man Hours Distribution",
  RESOURCE_HISTOGRAM: "Resource Histogram",
  VIEW_PROJECT_CHARTER: "View Project Charter",
  PROJECT_CHARTER: "Project Charter",
  CONFIRM: "Confirm",
  LOAD: "Load",
  CONTACT_NUMBER: "Contact Number",
  INCHARGE: "Incharge",
  ADDRESS_1: "Address 1",
  ADDRESS_2: "Address 2",
  ZIPCODE: "Zipcode",
  UPLOAD: "Upload",
  SELECT_FILE: "Choose File",
  FILE_UPLOAD_TYPE: "File Upload Type",
  SUPERVISOR: "Supervisor",
  PROJECT_NAME: "Project Name",
  PROJECT_CODE: "Project Code",
  SELECT_PROJECT: "Select Project",
  DELETE: "Delete",
  EDIT: "Edit",
  SAVE: "Save",
  CANCEL: "Cancel",
  HOME: "Home",
  PROJECTS: "Projects List",
  DASHBOARD: "Dashboard",
  GANTT_CHART: "Gantt Chart",
  USERS: "Users List",
  ORGANIZATION: "Organization",
  ORGANIZATIONS: "Organizations",
  LOGOUT: "Logout",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  USER_NAME: "Username",
  PASSWORD: "Password",
  LOGIN: "Login",
  REMEMBER_ME: "Remember Me",
  MENU: "Menu",
  SEARCH: "Search",
  EMAIL_ID: "Email ID",
  PHONE: "Phone Number",
  USER_TYPE: "User Type",
  ACTIVE: "Active",
  INACTIVE: "In Active",
  CHARGEABLE: "Chargeable",
  DIRECTOR: "Director",
  PROJECT_STATUS: "Project Status",

  //
  NEW: "New",
  STORE_VISIT: "Store Visit",
  RETAILER_DOCUMENT_VERIFICATION: "Retailer Document Verification ",
  QUALIFIED: "Qualified",
  CONVERTED: "Converted",
  //
  COMPANY_DEATAIL: "Company Detail",
  AREA_DEATAIL: "Area Detail",
  PERSONAL_DEATIL: "Personal Detail",
  PARTNER_DETAIL: "Partner Detail",
  STORAGE_DETAIL: "Storage Detail",
  WAREHOUSE_DETAIL: "Warehouse Details",
  BANK_DEATIL: "Bank & A/c. Detail",
  REG_ADDRESS: "Reg.Address",
  AREA: "Area",
  CITY: "City",
  TALUKA: "Taluka",
  DISTRICT: "District",
  ZONE: "Zone",
  STATE: "State",
  PIN_NO: "Pin No",
  FIRM_PAN: "Firm PAN",
  RELIGION: "Religion ",
  FIRM_GST: "Firm GST",
  FSSI_NO: "FSSAI No",
  BUS_START_DATE: "FSSAI Expiry Date",
  PROPRIETOR: "Proprietor",
  PARTNERSHIP: "Partnership",
  PVT_LTD: "Pvt.Ltd",
  LTD: "Ltd",
  CONTACT_PERSON_1_NAME: "Contact Person (1) Name ",
  CONTACT_PERSON_1_MOBILE: "Contact Person (1) Mobile Number ",
  CONTACT_PERSON_2_NAME: "Contact Person (2) Name ",
  CONTACT_PERSON_2_MOBILE: "Contact Person (2) Mobile Number ",
  AREA_VILLAGE: "Area/Village",
  NAME: "Name",
  MOBILE_NUMBER: "Mobile Number",
  HOME_ADDRESS: "Home Address",
  DATE_OF_BIRTH: "Date of Birth",
  DRIVING_LICENSE: "Driving License",
  PAN_NUMBER: "PAN Number",
  AADHAR_UID_NUMBER: "Aadhar-UID Number",
  SL_NO: "Sl No",
  PARTNER: "Partner",
  SQ_FT: "Sq.Ft",
  BANK_DETAIL: "Bank Detail",
  ACCOUNT_NUMBER: "Account Number",
  ACCOUNT_NAME: "Account Name ",
  BANK_NAME: "Bank Name",
  BRANCH: "Branch",
  TYPE_OF_ACCOUNT: "Type of Account",
  IFSC_NO: "IFSC No",
  APPOINTED_BY: "Appointed By",
  ADDRESS: "Address",

  ///
  ACTIVITY_BOARD: "Activity Board",

  //
  REFERENCE: "Reference",
  DEPOSIT_DETAIL: "Security Deposit Detail",
  AMOUNT: "Amount",
  DEPOSIT_DATE: "Deposit Date",
  FAMILY_DEATIL: "Family Detail",
  OTHER_FAMILY: "Other Family References",
  CONTACT: "Contact",
  RELATION: "Relation",
  NOMINEE_DETAILS: "Nominee Details",
  FULL_NAME: "Full Name",
  ENCLOSED_DOCUMENT: "Enclosed Below Documents",
  REMARK: "Remark",
  DOCUMENT_DETAILS: "Document Details",
  //

  FILE_UPLOAD: "File Upload",

  //
  ENTER_NAME: "Enter the name ",
  COUNTRY_NAME: "Country Name",
  COUNTRY_CODE: "Country Code",
  OPTIONS: "Options",
  STATE_NAME: "State Name ",
  BEAT: "Beat",
  BEAT_PJP: "Beat/PJP",
  BEAT_CODE: "Beat Code ",
  DAY: "Day",
  VEHICLE_NUMBER: "Vehicle Number",
  DRIVER_NAME: "Driver Name ",
  EXECUTIVE: "Executive",
  PIN_CODE: "Pin Code",
  AVERAGE_CALL_TIME: "Average Call Time",
  SORTING_ORDER: "Sorting Order",
  //
  ROI: "ROI",
  ROI_CALCULATER: "ROI Calculater",

  //
  GRAMS: "Grams",
  QUANTITY: "Quantity",
  IS_QUANTITATIVE: "Is Quantitative ?",
  ALIAS_NAME: "Alias Name",
  BOX: "Box",
  PRODUCT_INSIDE: "Product Inside",
  SKU_NAME: "SKU Name",
  TAX: "Tax",
  HSN_CODE: "HSN Code",
  MIN_PRICE: "Min. Price",
  SUB_CATEGORY: "Sub Category",
  SUB_CATEGORY_NAME: "Sub Category Name",
  UPLOAD_PHOTO: "Upload Photo",
};

export const CONFIRMS = {
  SURE_TO_LOGOUT: "Are you sure want to logout..?",
  DELETE_USER: "Are you sure want to delete this user..?",
  SURE_TO_APPROVE: "Are you sure want to approve this..?",
  SURE_TO_SAVE: "Are you sure want to save this..?",
};

export const SUCCESS = {
  RECORD_SUCCESS: "Record Saved Successfully..!",

  PASSWORD_CHANGED: "Password Changed Successfully..!",
  LOGIN_SUCCESS: "Login Successful, Redirecting to home page..!",
  LOGOUT_SUCCESS: "Logout successful, Redirecting to login page..!",
  SIGNUP_SUCCESS: "Signup successful..!",
  PROPERTY_SAVED: "Property Saved Successfully..!",
  FILE_UPLOADED: "File Uploaded Successfully..!",
  PROJECT_SUCCESS: "Project Saved Successfully..!",
  ORGANIZATION_SUCCESS: "Organization Saved Successfully..!",
  USER_SUCCESS: "User Saved Successfully..!",
  CHART_INFO_UPDATED: "Chart Info Updated Successfully..!",
  FILE_APPROVED: "File Approved Successfully..!",
};

export const WARNINGS = {
  ARE_YOU_SURE: "Are you sure..?",
  MANDATORY: "Please fill mandatory fields..!",
  PLEASE_FILL_MANDATORY_FIELDS: "Please fill all the mandatory fields..!",
  PLEASE_SELECT_ASSIGNED_BY: "Please select assigned by..!",
  QUESTION_EMPTY: "Please enter the question..!",
  WORK_PACKAGE_EMPTY: "Work Package is Mandatory..!",

  PROJECT_TYPE_EMPTY: "Project Type Name is Mandatory..!",
  DESIGNATION_NAME_EMPTY: "Designation Name is Mandatory..!",
  RESPONSIBILITY_NAME_EMPTY: "Responsibility Name is Mandatory..!",
  EMP_IS_EMPTY: "Employee is mandatory..!",

  BOTH_PASSWORDS_SAME: "Current & New Password should not be same..!",
  NPWD_LENGTH_SMALL:
    "New Password Length should be greater than 6 characters..!",
  CPWD_EMPTY: "Current Password is empty..!",
  NPWD_EMPTY: "New Password is empty..!",
  DATE_EMPTY: "Please select date..!",
  TASK_EMPTY: "Please select Task..!",
  FILE_NOT_FOUND: "File Not Found..!",
  INVALID_EMAIL: "Invalid Email ID..!",
  USER_TYPE_EMPTY: "Please Select User Type..!",
  USER_NAME_IS_EMPTY: "Please Enter User Name..!",
  FIRST_NAME_IS_EMPTY: "Please Enter First Name..!",
  CONTACT_NO_IS_EMPTY: "Please Enter Incharge Contact Number..!",
  INCHARGE_IS_EMPTY: "Please Enter Incharge Name..!",
  ORG_NAME_IS_EMPTY: "Please Enter Organization Name..!",
  ZIPCODE_IS_EMPTY: "Please Enter Zipcode..!",
  ADDRESS_IS_EMPTY: "Please Enter Address..!",
  SUPERVISOR_EMPTY: "Please select Supervisor..!",
  ORG_EMPTY: "Please select Organization..!",
  PROJECT_NAME_EMPTY: "Please enter the Project Name..!",
  PROJECT_EMPTY: "Please select project..!",
  FILE_EMPTY: "Please select file..!",
  USERNAME_IS_EMPTY: "Username is mandatory..!",
  PASSWORD_IS_EMPTY: "Password is mandatory..!",
  PROPERTY_TYPE_EMPTY: "Please select property type..!",
  STATE_EMPTY: "Please select state..!",
  CITY_EMPTY: "Please select city..!",
  AREA_EMPTY: "Please select Area..!",
  ADDRESS_EMPTY: "Please enter address..!",
  PROPERTY_NAME_EMPTY: "Please enter address..!",
  PROPERTY_DESC_EMPTY: "Please enter property description..!",
  PROPERTY_OWNER_EMPTY: "Please enter property owner name..!",
  DATA_IS_EMPTY: "Data cannot be empty..!",
  //
  FILE_SIZE_EXCEEDED: "File size exceeded..!",
};

export const ERRORS = {
  RECORD_FAILED: "Record Not Saved..!",

  LOGIN_FAILED: "Login Failed: Invalid Username or Password..!",
  LOGOUT_FAILED: "Logout failed..!",
  SCORE_FAILED: "Score Calculations Failed..!",
  FILE_NOT_UPLOADED: "File Not Uploaded Successfully..!",
  PROJECT_FAILED: "Project Not Saved..!",
  ORGANIZATION_FAILED: "Organization Not Saved..!",
  USER_FAILED: "User Not Saved..!",
  CHART_INFO_NOT_UPDATED: "Chart Info Not Updated Successfully..!",
  FILE_APPROVE_FAILED: "File Not Approved Successfully..!",
};

export const INFO = {
  CLICK_HERE_STREETVIEW: "Click for streetview",
  CONGRATULATION_LEAD_CONVERTED: "Congratulations, Lead is converted !!",
};
